import $ from "jquery";
import React, { Suspense, useEffect, useState } from 'react';
import { CSVLink } from "react-csv";
import { Link } from "react-router-dom";

import { toast } from "react-toastify";
import PostLoginGetApi from "../../../components/Api/PostLoginGetApi";
import DatePickerV2 from "../../../components/Date/DatePicker-v2";
import DatePickerRange from "../../../components/Date/DatePickerRange";
import number_format from "../../../components/Constants/NumberFormat"; 
import init from '../AccessControl/Check';


import { Area, AreaChart, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import moment from "moment";


var setDatePicker = () => {
    $("#date-div").hide();
    $("#date-range-div").hide();

    $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);


    var v = $("#date-range-data").val();
    if (v === "custom") {
        $("#date-range-div").show();
    }
    else if (v === "all") {
        $("#date-div").attr("style", "display:flex");
    }
}


const OrderSummary = () => {

    const pageName = "Order Summary";
    init(pageName);

    const [csvData, setCsvData] = useState([]);

    const [reqParam, setReqParam] = useState({});

    const [isFilter, setIsFilter] = useState(false);

    const [chartData, setChartData] = useState([]);
    const [history, setHistory] = useState([]);
    const [orderSummary, setOrderSummary] = useState([]);

    const [sum, setSum] = useState({pickup: 0, dineIn: 0, delivery: 0, accepted: 0, decline: 0});


    // Get Order Summary Report 
    useEffect(() => {
        PostLoginGetApi("report/order", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);


                if (responseData["code"] === 200) {
                    

                    let search_product_name = $("#product_id option:selected").text();
                    let search_category_name = $("#category_id option:selected").text();
                    

                    let i = 0;
                    let arr = [];
                    arr[i++] = ['','ORDER REPORT'];
                    arr[i++] = [];
                    arr[i++] = ['FILTER BY'];
                    arr[i++] = ['ORDER DATES', reqParam.from ?? "", reqParam.end ?? ""];
                    arr[i++] = ['PRODUCT NAME',  search_product_name ?? ""];
                    arr[i++] = ['CATEGORY NAME',  search_category_name ?? ""];
                    arr[i++] = [];
                    arr[i++] = ['#','ORDER DATE', 'PRODUCT NAME', 'CATEGORY NAME', 'ORDER QUANTITY', 'ORDER AMOUNT'];


                    let data = responseData["data"]["list"] ?? [];
                    let sum = responseData["data"]["sum"];
                    data.forEach((val, index)=>{
                        arr[i++] = [index+1, val.date, val.name, val.category_name, val.quantity, val.price];
                        i++;
                    });

                    arr[i++] = ['TOTAL', '', '', '', sum?.quantity, sum?.price];
                    setCsvData(arr);


                    setHistory(responseData["data"]["list"]);
                    setOrderSummary(responseData["data"]["sum"]);
                    return;
                }
                toast.error(responseData["messages"].toString());
                return;
            }
        }).catch((err) => {
            console.log(err);
        });

    }, [isFilter, reqParam]);



    // Get Product & Category
    const [productList, setProductList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    useEffect(()=> {
        PostLoginGetApi("item-all", reqParam, 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);


                if (responseData["code"] === 200) {
                    setProductList(responseData["data"]);
                    return;
                }
                toast.error(responseData["messages"].toString());
                return;
            }
        }).catch((err) => {
            console.log(err);
        });


        PostLoginGetApi("category", "", 2).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    setCategoryList(responseData["data"]);
                    return;
                }
            }
        }).catch((err) => {
            console.log(err);
        });



    }, []);

    const filterClick = () => {
        console.log("first")
        $("#filter-toggle-icon").toggleClass("rotate-180");
        $(".custom-btn.filter").toggleClass("active");

        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const closeClick = () => {
        $("#filter-div").toggleClass("need-without-shadow");
        $("#filter-div").toggleClass("no-need-without-shadow");
    }

    const filter = (isReset = 1) => {
        setSum({pickup: 0, dineIn: 0, delivery: 0, accepted: 0, decline: 0});

        // Date Filter
        var from = "", end = "";

        if (isReset !== 1) {
            const filterType = $("#date-range-data").val();
            if ((!$("#fromDate").val() || !$("#toDate").val()) && filterType === "custom") {
                toast.error('Please enter filter dates.');
                return;
            }


            if (filterType === "all" && !$("#singleDatePicker").val()) {
                toast.error("Please enter filter date.");
                return;
            }
        }

        if ($("#date-range-data").val() === "custom") {
            from = $("#fromDate").val();
            end = $("#toDate").val();

            if (from.length === 0 || end.length === 0) {
                from = "";
                end = "";
            }
            else {
                let nextDate = new Date(end);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");
                end = nextDate;
            }

        }
        else if ($("#date-range-data").val() === "all") {
            const singleDatePicker = $("#singleDatePicker").val();
            if (singleDatePicker.length !== 0) {
                let nextDate = new Date(singleDatePicker);
                nextDate.setDate(nextDate.getDate() + 1);
                nextDate = nextDate.getFullYear() + "-" + (nextDate.getMonth() + 1) + "-" + nextDate.getDate();
                nextDate = moment(nextDate).format("YYYY-MM-DD");

                from = singleDatePicker;
                end = nextDate;
            }
        }

        let product_id = $("#product_id").val();
        if( product_id === "0" ) {
            product_id = "";
        }

        let category_id = $("#category_id").val();
        if( category_id === "0" ) {
            category_id = "";
        }
        


        setReqParam({ ...reqParam, from: from, end: end, product_id: product_id, category_id: category_id });
        if (from !== "" || end !== "" ) {
            setIsFilter(true);
        }
    }


    const resetFilterData = () => {
        $("#date-range-data").val("custom");
        $("#fromDate, #toDate, #singleDatePicker").datepicker('setDate', null);
        $("#to-date-picker").val("");
        $("#product_id, #category_id").val("0");

        setDatePicker();
        filter(1);
        setIsFilter(false);
    }



    return (
        <Suspense fallback={<div>Loading...</div>}>
            <div className="custom-container w-full h-screen pb-10 font-montserrat flex ">

                <>
                    {/** Left Side */}
                    <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full h-screen mb-20 pb-[150px] pr-3 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>

                        <div className="w-full text-justify rounded-[5px] py-3 pt-2 flex" style={{boxShadow: "0 8px 4px -6px rgba(0, 0, 0, 0.03)"}}>
                            <div className="w-1/2 float-left">
                                <h6 className="text-xl px-4 font-medium pb-0 pl-0 pt-3">Here’s your shop product based reports</h6>
                            </div>

                            <div className="w-1/2 h-[68px] float-left text-right justify-end flex items-center">
                                <CSVLink className="custom-btn mr-2 text-center" filename={"order-report.csv"} data={csvData}>Export CSV</CSVLink>
                                <Link to="#" onClick={filterClick} className="custom-btn filter text-center w-[92px] active">Filter</Link>
                                <svg id="filter-toggle-icon" className='static -ml-4' width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" fill="#1A202C" />
                                    <path d="M17 19L13 15L17 11" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <rect x="0.5" y="0.5" width="29" height="29" rx="14.5" stroke="#F5F5F5" />
                                </svg>
                            </div>

                        </div>


                        {/* <div className='w-full h-[300px] my-5 relative -ml-5'>
                            <BarChart />
                            {chartData.length > 0 && (
                                <ResponsiveContainer className="absolute" width="100%" height="100%">
                                    <AreaChart
                                        width={500}
                                        height={400}
                                        data={chartData}
                                    >
                                        <defs>
                                            <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                                                <stop offset="30%" stopColor="#03A629" stopOpacity={1} />
                                                <stop offset="95%" stopColor="#03A629" stopOpacity={0.2} />
                                            </linearGradient>
                                        </defs>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="booking_date" fontSize={13} />
                                        <YAxis fontSize={13} />
                                        <Tooltip />
                                        <Legend verticalAlign="top" height={36} />
                                        <Area type="monotone" dataKey="accepted" stroke="#03A629" fill="url(#colorUv)" />
                                        <Area type="monotone" dataKey="decline" stroke="#FD171B" fill="#FD171B" />
                                    </AreaChart>
                                </ResponsiveContainer>
                            )}
                        </div> */}


                        <div className='w-full max-w-full h-auto mt-5 mb-5 flex items-center overflow-x-auto'>
                            {(history.length > 0) ? 
                            <table className="table-auto w-full m-auto h-auto mt-2" border={0}>
                                <thead>
                                    <tr className='bg-[#F5F5F5] mt-2'>
                                        <td className="mt-2 pt-4 pb-4 rounded-l-md font-semibold text-center" style={{width: "50px"}}>#</td>
                                        <td className="mt-2 pt-4 pb-4 pl-4 font-semibold" style={{width: "150px"}}>Date</td>
                                        <td className="mt-2 pl-4 pt-4 pb-4 font-semibold">Product Name</td>
                                        <td className="mt-2 pt-4 pb-4 font-semibold text-center">Category</td>
                                        <td className="mt-2 pt-4 pb-4 text-center font-semibold" title="Sale Quantity" style={{width: "150px"}}>Quantity</td>
                                        <td className="mt-2 pt-4 pb-4 text-center font-semibold" title="Price after discount" style={{width: "200px"}}>Order Amount</td>
                                        {/* <td className="mt-2 pt-4 pb-4 rounded-r-md text-center font-semibold" style={{width: "200px"}}>Discount</td> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {history.map((val, index)=>
                                        <tr key={index} className="hover-black-green border-b-2">
                                            <td className="mt-2 pt-4 pb-4 border-r-2 rounded-l-md text-center font-semibold">{index+1}</td>
                                            <td className="mt-2 pt-4 pb-4 pl-4 border-r-2 rounded-r-none">{moment(val.date, "YYYY-MM-DD").format("DD MMM, YYYY")}</td>
                                            <td className="mt-2 pt-4 pl-4 pb-4 border-r-2 rounded-r-none">{val.name}</td>
                                            <td className="mt-2 pt-4 pb-4 border-r-2 rounded-r-none text-center">{val.category_name}</td>
                                            <td className="mt-2 pt-4 pb-4 border-r-2 rounded-r-none text-center">{val.quantity}</td>
                                            <td className="mt-2 pt-4 pb-4 border-r-2 rounded-r-none text-center">{number_format(val.price,2)}</td>
                                            {/* <td className="mt-2 pt-4 pb-4 rounded-r-md text-center">{number_format(val.discount,2)}</td> */}
                                        </tr>
                                    )}
                                </tbody>

                                <tfoot>
                                    <tr className='bg-[#F5F5F5] mt-2 border-t-0'>
                                        <td className="mt-2 pt-4 pb-4 border-r-2 rounded-l-md pl-4 font-semibold" colSpan={4}>TOTAL</td>
                                        <td className="mt-2 pt-4 pb-4 border-r-2 text-center font-semibold">{orderSummary?.quantity ?? 0}</td>
                                        <td className="mt-2 pt-4 pb-4 border-r-2 text-center font-semibold">{number_format(orderSummary?.price ?? 0,2)}</td>
                                        {/* <td className="mt-2 pt-4 pb-4 border-r-md text-center font-semibold">{number_format(orderSummary?.discount ?? 0,2)}</td> */}
                                    </tr>
                                </tfoot>
                            </table>
                            :
                            <div className="custom-container-left float-left custom-scroll-auto min-w-[80%] w-full h-screen mb-20 pb-[150px] pr-3 text-justify" style={{ boxShadow: "3px 0 0px 0px rgb(0 0 0 / 1%)" }}>
                                <h2 className='py-4 px-2 text-xl'>No order report data available</h2>
                            </div>
                            }

                        </div>

                    </div>

                </>
                

                
                {/** Right Side */}
                <div id="filter-div" style={{ overflowX: "hidden" }} className="custom-container-right custom-scroll-auto h-screen float-right w-1/5 pl-2 pb-10 pt-4 pr-0 justify-center mb-20 need-without-shadow">
                    <div style={{ overflowX: "hidden" }} className="relative custom-scroll-auto">
                        
                        <h6 className="text-lg px-3 font-base pb-2 pl-2 whitespace-nowrap" style={{ boxShadow: "0 3px 0 0 rgb(0 0 0 / 1%)" }}>Filter Report</h6>

                        <div className="relative">
                            <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                                <div className="w-full float-left pt-2  mb-3">
                                    <select onChange={setDatePicker} id="date-range-data" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="custom">
                                        <option value="all">Single Date</option>
                                        <option value="custom">Date Range</option>
                                    </select>
                                    <DatePickerV2 />
                                    <DatePickerRange />
                                </div>
                            </div>

                            <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                                <div className="w-full float-left pt-2">
                                    <select id="product_id" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="0">
                                        <option value="0">All Products</option>
                                        {(productList.length === 0) ? (
                                            <></>
                                        ) : (
                                            <>
                                                {productList.map((val, index) => (
                                                    <option key={index} value={val?.id} >{val?.name}</option>
                                                ))}
                                            </>
                                        )}
                                    </select>
                                </div>
                            </div>


                            <div className="box-full w-full  text-justify py-2 pl-2 pr-1">
                                <div className="w-full float-left">
                                    <select id="category_id" className='w-full mt-0 mb-4 bg-[#F5F5F5] rounded border-0' defaultValue="0">
                                        <option value="0">All Category</option>
                                        {(categoryList.length === 0) ? (
                                            <></>
                                        ) : (
                                            <>
                                                {categoryList.map((val, index) => (
                                                    <option key={index} value={val?.id} >{val?.name}</option>
                                                ))}
                                            </>
                                        )}
                                    </select>
                                </div>
                            </div>

                            <div className="box-full w-full text-justify py-2 pl-3 pr-1 mt-6">
                                <button onClick={filter} className="custom-btn box-full w-full text-center py-1 pl-2 pr-1">Filter</button>

                                {isFilter && <button onClick={resetFilterData} className="custom-btn bg-black text-white border-black mt-3 box-full w-full text-center py-2 pl-2 pr-1" style={{ color: "#FFF" }}>Reset Filter</button>}
                                <button className="hidden mb-close-btn py-2.5 px-5 rounded w-[97%] ml-2 mt-3 bg-red-400 text-white" onClick={closeClick}>Close</button>
                            </div>

                        </div>
                    </div>
                </div>

            </div>

        </Suspense >
    );
};

export default OrderSummary;